import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-time',
  templateUrl: './operation-time.component.html',
  styleUrls: ['./operation-time.component.scss']
})
export class OperationTimeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
